import * as React from 'react';
import { GlobalNavigationMenu } from '@/components';
import { navLinks } from '@/data';
import { CurtinLogo } from './CurtinLogo';

export const Header = React.forwardRef<HTMLElement, HeaderProps>(
  ({ applicationTitle, applicationSubtitle, isGlobalHeader, isForSearchApplication }, ref) => (
    <header
      ref={ref}
      className="sticky top-0 z-50 flex h-full w-full min-w-[300px] items-center justify-between border border-x-white bg-white shadow-sm
        lg:min-h-[110px] lg:px-10"
    >
      <div className="mx-auto flex h-full w-full max-w-screen-2xl lg:items-center">
        <CurtinLogo className="px-5 py-[10px] lg:px-0 lg:py-0" />
        {(applicationTitle || applicationSubtitle) && (
          <div
            className="min-w-15 lf text-b3_md lg:text-b3 mx-5 flex w-fit flex-none flex-col items-start self-center break-keep align-middle
              uppercase leading-4"
          >
            {applicationTitle && <span className="block font-bold">{applicationTitle}</span>}
            {applicationSubtitle && <span className="block font-normal">{applicationSubtitle}</span>}
          </div>
        )}
        <nav id="main-nav" className="flex h-full flex-1 flex-col lg:min-h-[90px]">
          <GlobalNavigationMenu
            globalNavigationMenuLinks={navLinks}
            hasSecondaryNav={isGlobalHeader}
            hasSearchIcon={!isForSearchApplication}
          />
        </nav>
      </div>
    </header>
  ),
);
Header.displayName = 'Header';

export interface HeaderProps extends React.HTMLProps<HTMLElement> {
  applicationTitle?: string;
  applicationSubtitle?: string;
  isGlobalHeader?: boolean;
  isForSearchApplication?: boolean; // Used ONLY for global search, to show 'X' instead of mag glass icon
}
